type FilterComboBoxOptionsParams<OPTION> = {
	options: readonly OPTION[];
	filterOptions?: (options: readonly OPTION[], inputValue: string) => readonly OPTION[];
	inputValue: string | undefined;
	value: OPTION | null | undefined;
	optionToString: (option: OPTION) => string;
	pristine: boolean;
};

export function filterComboBoxOptions<OPTION>({
	options,
	filterOptions,
	inputValue,
	value,
	optionToString,
	pristine,
}: FilterComboBoxOptionsParams<OPTION>): readonly OPTION[] {
	if (filterOptions) return filterOptions(options, inputValue ?? '');

	// FIXME we should be using the user's chosen locale instead of the browser's
	// eslint-disable-next-line @change-corgi/no-locale-case-without-locale
	const lowerCaseInput = (inputValue ?? '').toLocaleLowerCase();
	// eslint-disable-next-line @change-corgi/no-locale-case-without-locale
	const lowerCaseValue = value ? optionToString(value).toLocaleLowerCase() : '';

	// return all options if first time combobox is opened (pristine)
	if (pristine && lowerCaseInput === lowerCaseValue) return options;

	// else return filtered options (onInputChange)
	// eslint-disable-next-line @change-corgi/no-locale-case-without-locale
	return options.filter((option) => optionToString(option).toLocaleLowerCase().startsWith(lowerCaseInput));
}

export function inputDiffersFromOption<OPTION>(
	inputValue: string | undefined,
	option: OPTION,
	optionToString: (option: OPTION) => string,
): boolean {
	// FIXME we should be using the user's chosen locale instead of the browser's
	// eslint-disable-next-line @change-corgi/no-locale-case-without-locale
	return inputValue?.toLocaleLowerCase() !== optionToString(option).toLocaleLowerCase();
}
